import React from 'react';

export const Swiper = React.lazy(() =>
  import('./Swiper').then(({ Swiper }) => ({
    default: Swiper,
  })),
);
